import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'

import {
  AppService,
  EmailSourceType,
  I18nService,
  IBeatmakerData,
  ILicense,
  ILicenseBulkDiscount,
  LgType,
  LicensesBulkDiscountService,
  LicenseService,
  SetColorsService
} from 'core'

@Component({
  selector: 'bmprod-home-page',
  templateUrl: './bmprod-home-page.component.html',
  styleUrls: ['./bmprod-home-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmprodHomePageComponent implements OnInit {
  lg: LgType

  colorSettingsMode = false
  beatmakerData: IBeatmakerData
  sourceType = EmailSourceType.ProducerPage // Need to determine where the letter came from (bmcore-contacts-form)

  licenses: ILicense[] = []
  licenseBulkDiscounts: Array<ILicenseBulkDiscount> = []

  constructor(
    private setColorsService: SetColorsService,
    private appService: AppService,
    private licenseService: LicenseService,
    private licensesBulkDiscountService: LicensesBulkDiscountService,
    private i18nService: I18nService
  ) {}

  ngOnInit(): void {
    this.lg = this.i18nService.getLanguageForPage()
    this.appService.beatMakerDataSubject.subscribe(res => {
      if (res?.beatmakerId) {
        this.beatmakerData = res
        this.licenseService.getLicenses(res.beatmakerId)
        this.licensesBulkDiscountService.getLicensesDiscount(res.beatmakerId)
      }
    })

    this.getLicenses()
    this.getLicenseDiscounts()
    this.getColorSettingsMode()
  }

  getLicenses() {
    this.licenseService.licensesSubject.subscribe(res => {
      this.licenses = res
    })
  }

  getLicenseDiscounts() {
    this.licensesBulkDiscountService.licenseDiscountSubject.subscribe(res => {
      this.licenseBulkDiscounts = res
    })
  }

  getColorSettingsMode() {
    this.setColorsService.colorSettingsSubject.subscribe(res => {
      this.colorSettingsMode = res
    })
  }
}
